(function($, undefined) {

	var selector = '.inp-file';
	var InpFile = function (el) {
		var _this = this;

		this.el = el;
		this.input = el.querySelector(selector + '__input');
		this.img = el.querySelector(selector + '__img');
		this.remove = el.querySelector(selector + '__remove');

		this.input.addEventListener('change', this.handleChange.bind(this));
		this.remove.addEventListener('click', this.handleRemove.bind(this));


		this.el.addEventListener('drop', this.handleDrop.bind(this));
		this.el.ondragover = this.el.ondragenter = function(e) {
			e.preventDefault();
		};
	};

	InpFile.prototype.handleChange = function (e) {
		if (! ('FileReader' in window)) {
			return;
		}

		var files = e.target.files;
		var _this = this;

		for (var i = 0; i < files.length; i++) {
			var file = files[i];

			if ( ! file.type.match('image.*')) {
				continue;
			}

			var reader = new FileReader();

			reader.onload = (function (theFile) {
				return function (e) {
					_this.el.classList.add(selector.substr(1) + '--filled-in');
					_this.img.src = e.target.result;
				};
			})(file);

			reader.readAsDataURL(file);
		}
	}
	InpFile.prototype.handleRemove = function (e) {
		e.preventDefault();
		e.stopPropagation();

		this.input.value = '';
		this.el.classList.remove(selector.substr(1) + '--filled-in');

		this.emmitChange(e);
	}
	InpFile.prototype.handleDrop = function (e) {
		this.input.files = e.dataTransfer.files;
		this.emmitChange(e);

		e.preventDefault();
	};
	InpFile.prototype.emmitChange = function (e) {
		var evt = new CustomEvent('change', { bubbles: true });
		this.input.dispatchEvent(evt);
	}


	/**
	 * @author Radek Šerý
	 *
	 * Input pro nahrávání obrázků
	 */
	$.nette.ext('inpFile', {
		init: function() {
			var snippetsExt = this.ext('snippets', true);
			var ext = this;

			snippetsExt.after(function($el) {
				ext.init.call(ext, $el);
			});

			this.init($(document));
		}
	}, {
		selector: selector,
		init: function($el) {
			$el
				.find(this.selector)
				.each(function() {
					setTimeout(() => {
						var inpFile = new InpFile(this)
					}, 0)
				});
		}
	});

})(jQuery);
